<script>
/**
 * ****************************************************************************
 * @description     :   panel Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of panel component
 */
var AnsPanel = {
    template: template,
    props: {
        customizeFcPanelClass: {
            type: [String, Object],
            default: {}
        },
        customizeFcPanelStyle: {
            type: [String, Object],
            default: {}
        },
        label: String,
        labelAfter: String,
        subLabel: String,
        listName: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        panelClass: String,
        value: [String, Number],
        modelValue: [String, Number],
        default: {
            type: Boolean,
            default: true
        },
        isShow: {
            type: Boolean,
            default: true
        },
        disableToggle: {
            type: Boolean,
            default: false
        },
        isShowIconDrop: {
            type: Boolean,
            default: true
        },
        isShowIconPanel: {
            type: Boolean,
            default: true
        },
        customizeShowContent: {
            type: Boolean,
            default: false
        },
        iconPanel: String,
        isDisabled: Boolean,
        options: Array,
        onChange: Function
    },
    data() {
        return {
            show: this.isShow,
            id: _.uuid()
        };
    },
    methods: {
        toggle() {
            if (this.disableToggle) return;
            this.show = !this.show;
            this.$emit('toggle-panel', {
                show: this.show
            });
        }
    },
    computed: {
        fcPanelClass() {
            const baseClasses = {
                'visually-hidden': !this.show && !this.customizeShowContent,
                'border-solid-common': true,
                'border-top-0': true
            };

            if (typeof this.customizeFcPanelClass === 'object' && this.customizeFcPanelClass !== null) {
                return { ...baseClasses, ...this.customizeFcPanelClass };
            } else if (typeof this.customizeFcPanelClass === 'string' && this.customizeFcPanelClass) {
                return { ...baseClasses, [this.customizeFcPanelClass]: true };
            }

            return baseClasses;
        },
        fcPanelStyle() {
            const baseStyles = {};

            if (typeof this.customizeFcPanelStyle === 'object' && this.customizeFcPanelStyle !== null) {
                return { ...baseStyles, ...this.customizeFcPanelStyle };
            }

            return baseStyles;
        }
    }
};
export default AnsPanel;
</script>
